import persistReducer from "redux-persist/es/persistReducer"
import storage from "redux-persist/lib/storage"
import {
  API_ERROR,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  user: {},
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: action.payload,
      }
      break
    case LOGOUT_USER:
      state = { ...state, user: {} }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

const persistConfig = {
  keyPrefix: "beumont-",
  key: "login",
  storage,
}

export default persistReducer(persistConfig, login)
